<template>
  <div class="sc-tv-channels">
    <base-button v-if="false" variant="text" class="back-button" @click="closeChannelList"><i class="icon-sc-chevron-left "></i> {{ $t('common.back') }}</base-button>
    <base-heading v-if="$props.packageName" :underline="false" class="tv-package-name"> {{ $props.packageName }}</base-heading>
    <base-heading v-else :underline="false">{{ $t('tvPage.channelList.title') }}</base-heading>
    <p class="total-channels slim" v-if="$props.totalChannels">{{ $props.totalChannels }} {{ $t('addons.totalChannels') }}</p>
    <div class="tabs-wrapper scrolled-left scrolled-right" :class="{'with-arrows': showArrows}">
      <base-button variant="text"
                   class="scroll-button"
                   @click="moveList('left')"
                   :disabled="!tabsOverflowedLeft">
        <i class="icon-sc-chevron-left"></i>
      </base-button>
      <div class="tabs-container"
           v-dragscroll.x="showArrows"
           @dragscrollmove="handleDrag"
           @dragscrollstart="handleDragStart"
           @dragscrollend="handleDragEnd"
           ref="tabsContainer">
        <ul role="menubar" class="category-tabs" ref="tabs">
          <li class="single-tab"
              v-for="(category, index) in channelCategories"
              :key="'cat'+index"
              ref="singleTab"
              :class="{active: category === selectedCategory}">
            <a href="#" @click.prevent="selectCategory(index, category)">{{ category }}</a>
          </li>
        </ul>
      </div>
      <base-button variant="text"
                   class="scroll-button"
                   @click="moveList('right')"
                   :disabled="!tabsOverflowedRight">
        <i class="icon-sc-chevron-right"></i>
      </base-button>
    </div>
    <h3 class="total-channels" v-if="$props.showChannelCount">{{ `${getProperCase(selectedCategory)} ${$t('tvPage.channelList.channelsWord')} - ${ selectedCategoryChannels ? selectedCategoryChannels.totalProductCount : ''}` }}</h3>
    <transition name="fade" mode="out-in">
      <ul class="channel-list" v-if="selectedCategoryChannels && selectedCategoryChannels.products && selectedCategoryChannels.products.length" :key="channelsKey">
        <li class="single-channel"
            v-for="(channel, idx) in selectedCategoryChannels.products"
            :key="'channel'+idx">
          <img v-if="channel && channel.images && channel.images.length"
               :src="channel.images[0].url"
               :alt="channel.name"
               class="channel-image">
          <h4 class="channel-name">{{ channel.name }}</h4>
          <p class="channel-position">{{$t('tvPage.channelList.channelPosition')}} - {{ channel.channelPosition }}</p>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'
import debounce from '@/utils/debounce'

const DEFAULT_CATEGORY = 'Svi'
const DEFAULT_SCROLL_VALUE = 50
let tempTimeout = null
export default {
  name: 'television-channel-list',
  data () {
    return {
      selectedCategory: DEFAULT_CATEGORY,
      channelsKey: new Date().getTime(),
      tabsOverflowedLeft: false,
      tabsOverflowedRight: false,
      preventSelect: false,
      totalItemsWidth: 0,
      showArrows: false,
      resizeFunc: () => this.customDebounce(() => this.calculateScrollingContainer(), 100)
    }
  },
  directives: {
    dragscroll: dragscroll
  },
  computed: {
    channelCategories () {
      if (this.$props.channelData.length > 0) {
        const categories = [DEFAULT_CATEGORY]
        this.$props.channelData.forEach(item => {
          if (item.products.length && item.categoryName !== DEFAULT_CATEGORY) {
            categories.push(item.categoryName)
          }
        })

        return categories
      }
      return []
    },
    selectedCategoryChannels () {
      return this.$props.channelData.find(item => item.categoryName === this.selectedCategory)
    }
  },
  props: {
    channelData: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },
    packageName: String,
    showChannelCount: {
      type: Boolean,
      default: true
    },
    totalChannels: [String, Number]
  },
  methods: {
    closeChannelList () {
      this.$emit('close-channels')
    },
    selectCategory (index, category) {
      if (!this.preventSelect) {
        this.selectedCategory = category
        this.channelsKey = new Date().getTime()
        this.checkTabPosition(this.$refs.singleTab[index])
      }
    },
    checkTabPosition (tabElement) {
      const container = this.$refs.tabsContainer
      const tabPosLeft = tabElement.getBoundingClientRect().left
      const tabWidth = tabElement.getBoundingClientRect().width
      const containerPosLeft = container.getBoundingClientRect().left
      const containerWidth = container.getBoundingClientRect().width
      const buffer = DEFAULT_SCROLL_VALUE
      // case when it's left
      if (tabPosLeft < containerPosLeft + buffer) {
        this.scrollList(tabPosLeft - containerPosLeft - buffer)
      }
      if (containerPosLeft + containerWidth < tabPosLeft + tabWidth + buffer) {
        this.scrollList(tabWidth + buffer)
      }
    },
    getProperCase (category) {
      if (category.endsWith('i')) return category + 'h'
      return category
    },
    handleDrag (e) {
      const elem = e.target ? e.target : e
      debounce(() => {
        this.tabsOverflowedLeft = elem.scrollLeft > 0
        this.tabsOverflowedRight = elem.scrollLeft + this.$refs.tabsContainer.getBoundingClientRect().width < this.totalItemsWidth
      }, 10)
    },
    handleDragStart () {
      this.preventSelect = true
    },
    handleDragEnd () {
      setTimeout(() => {
        this.preventSelect = false
      }, 50)
    },
    getItemsTotalWidth (itemList) {
      let totalWidth = 0
      itemList.forEach(item => {
        totalWidth += item.getBoundingClientRect().width
      })

      return totalWidth
    },
    scrollList (scrollValue) {
      this.$refs.tabsContainer.scroll({
        left: this.$refs.tabsContainer.scrollLeft + scrollValue,
        top: 0,
        behavior: 'smooth'
      })
      setTimeout(() => {
        this.handleDrag(this.$refs.tabsContainer)
      }, 300)
    },
    moveList (direction) {
      const scrollValue = direction === 'right' ? DEFAULT_SCROLL_VALUE : -DEFAULT_SCROLL_VALUE
      this.scrollList(scrollValue)
    },
    calculateScrollingContainer () {
      if (!this.$refs.singleTab) return

      this.totalItemsWidth = this.getItemsTotalWidth(this.$refs.singleTab)
      if (this.$refs.tabsContainer.getBoundingClientRect().width < this.totalItemsWidth) {
        this.tabsOverflowedRight = true
        this.showArrows = true
      } else {
        this.tabsOverflowedRight = false
        this.tabsOverflowedLeft = false
        this.showArrows = false
      }
    },
    customDebounce (fn, timeout) {
      if (tempTimeout) clearTimeout(tempTimeout)
      tempTimeout = setTimeout(() => {
        fn()
      }, timeout)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.calculateScrollingContainer()
      window.addEventListener('resize', this.resizeFunc)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeFunc)
  }
}
</script>

<style scoped lang="scss">
.sc-tv-channels {
  padding-top: 0;

  .back-button {
    margin-bottom: 1.6rem;

    i {
      font-size: 1.2rem;
      margin-right: 1.6rem;
    }
  }

  .tabs-wrapper {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    border-bottom: 1px solid $form-border-color;
    margin-bottom: 2.4rem;

    &::before, &::after {
      position: absolute;
      content: '';
      top: 0;
      height: 100%;
      width: 2rem;
      z-index: 1;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s;
    }

    &::before {
      left: 1rem;
      background-image: linear-gradient(to right, $work-area 0%, rgba($work-area, 1) 50%, rgba($work-area, 0) 100%);
    }

    &::after {
      left: auto;
      right: 1rem;
      background-image: linear-gradient(to right, rgba($work-area, 0) 0%, rgba($work-area, 1) 50%, $work-area 100%);
    }

    .scroll-button {
      position: relative;
      z-index: 2;
      font-size: 1.4rem;
      padding: 1rem 1rem 1rem 0 !important;
      display: none;

      &:nth-of-type(2) {
        padding: 1rem 0 1rem 1rem !important;
      }
    }

    &.with-arrows {
      &.scrolled-left::before {
        opacity: 1;
      }

      &.scrolled-right::after {
        opacity: 1;
      }

      .scroll-button {
        display: block;
      }
    }
  }

  .tabs-container {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }

  .tabs-wrapper.with-arrows .tabs-container {
    padding: 0 1rem;
    cursor: -webkit-grabbing;
    cursor: -moz-grabbing;
    cursor: -o-grabbing;
    cursor: grabbing;
  }

  .category-tabs {
    padding: 0;
    margin: 0 0 -1px;
    display: flex;

    li.single-tab {
      a {
        padding: 1rem 0 0.8rem;
        margin: 0 1.8rem;
        display: block;
        text-decoration: none;
        color: $dark-grey;
        font-size: 1.4rem;
        user-select: none;
        border-bottom: 3px solid transparent;
        transition: color 0.2s, border-color 0.2s;
      }

      &:first-child a {
        margin-left: 0;
      }

      &.active a {
        margin: 0 1.7rem -1px;
        padding: 0.7rem 0;
        font-size: 1.6rem;
        font-weight: 600;
        color: $primary;
        border-color: $primary;
      }

      &:first-child.active a {
        margin-left: 0;
        margin-right: 1.7rem;
      }
    }
  }

  .total-channels {
    margin: 2.4rem 0 1.6rem;
    font-size: 1.6rem;
    font-weight: bold;
    color: $text;
    text-transform: uppercase;

    &.slim {
      font-weight: normal;
      text-transform: none;
      margin-top: -2.4rem;
      font-size: 1.4rem;
    }
  }

  .channel-list {
    display: flex;
    flex-wrap: wrap;
    margin: -0.4rem;

    .single-channel {
      background-color: $white;
      margin: 0.4rem;
      padding: 0.8rem;
      border-radius: 5px;
      flex-grow: 0;
      flex-shrink: 1;
      flex-basis: calc(50% - 0.8rem);
      display: flex;
      flex-direction: column;
      align-items: center;

      @media (map_get($breakpoints, sm)) {
        flex-basis: calc(33.33334% - 0.8rem);
      }

      @media (map_get($breakpoints, md)) {
        flex-basis: calc(25% - 0.8rem);
      }

      @media (map_get($breakpoints, lg)) {
        flex-basis: calc(20% - 0.8rem);
      }

      .channel-image {
        display: block;
        margin: auto auto 0.8rem;
        width: 100%;
        max-width: 110px;
        height: auto;
      }

      .channel-name {
        font-size: 1.6rem;
        font-weight: 600;
        color: $text;
        text-align: center;
        margin: auto 0 0;
      }

      .channel-position {
        text-align: center;
        font-size: 1.4rem;
        color: $dark-grey;
        margin: 0;
      }
    }
  }
}
</style>
